<template>
   <div class="modal fade modal-upload" id="editTourInfo" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="center-modal">
                        <div class="registerTourInfo">
                            <div class="box-heading">
                                <div class="title-precheck-info">{{ $t('tour.precheck.precheckTour') }}</div>
                                <p>収支明細に記載される情報を確認してください。<br>下見などで内容が異なる場合は訂正してください。</p>
                            </div>
                            <div class="box-body" v-if="tourInfo">
                                    <div class="body-tour">
                                        <div class="row-cnt">
                                            <label class="cnt-title">{{ $t('tour.tour_number') }}</label>
                                            <label class="cnt-item">{{ tourInfo.tour_number }}({{ storageService.getCashName() }})</label>
                                        </div>
                                        <div class="row-cnt">
                                            <div class="cnt-title">{{ $t('tour.precheck.tour_name') }}</div>
                                            <textarea
                                                class="cnt-item"
                                                name="tourName"
                                                v-model=tourInfo.name
                                                :style="{ 'background-color' : errorTourName == true ? 'pink' : 'white' }"
                                            ></textarea>
                                        </div>

                                        <div class="row-cnt">
                                            <div class="cnt-side-title">{{ $t('tour.departure_date') }}</div>
                                            <div class="cnt-side-title">{{ $t('tour.return_date') }}</div>
                                        </div>
                                        <div class="row-cnt">
                                            <div class="cnt-side-item" :style="{ 'border' : errorDepartureDate ? 'solid 2px red' : 'none' } ">
                                                <date-picker
                                                    name="departureDate"
                                                    format="YYYY年MM月DD日"
                                                    v-model=tourInfo.departure_date
                                                    style="width: 100%;"
                                                    :editable="false">
                                                </date-picker>
                                            </div>
                                            <div class="cnt-side-item" :style="{ 'border' : errorReturnDate ? 'solid 2px red' : 'none' } ">
                                                <date-picker
                                                    name="returnDate"
                                                    format="YYYY年MM月DD日"
                                                    v-model=tourInfo.return_date
                                                    style="width: 100%;"
                                                    :editable="false">
                                                </date-picker>
                                            </div>
                                        </div>

                                        <div class="row-cnt">
                                            <div class="cnt-side-title">{{ $t('tour.person_count') }}</div>
                                            <div class="cnt-side-title">{{ $t('tour.conductor_number') }}</div>
                                        </div>
                                        <div class="row-cnt">
                                            <input ref="person" class="cnt-side-item text-num"
                                                type="text"
                                                name="personCount"
                                                v-model=tourInfo.person_count
                                                inputmode="numeric"
                                                autocomplete="off"
                                               @focus="$refs.person.select()"
                                                :style="{ 'background-color' : (errorPersonCount || errorTotalNo) ? 'pink' : 'white' }"
                                            >
                                            <input ref="conductor" class="cnt-side-item text-num"
                                                type="text"
                                                name="conductorNumber"
                                                v-model=tourInfo.conductor_number
                                                inputmode="numeric"
                                                autocomplete="off"
                                               @focus="$refs.conductor.select()"
                                                :style="{ 'background-color' : errorConductorNumber ? 'pink' : 'white' }"
                                            >
                                        </div>
                                    </div>

                                    <div class="body-teach-travel">
                                        <label class="title-teach-travel">{{ $t('tour.precheck.areaTeachTravel') }}</label>

                                        <div class="row-cnt-just">
                                            <div class="side-title">{{ $t('tour.precheck.student') }}</div>
                                            <div class="side-title">{{ $t('tour.precheck.teacher') }}</div>
                                            <div class="side-title">{{ $t('tour.precheck.nurse') }}</div>
                                            <div class="side-title">{{ $t('tour.precheck.cameraman') }}</div>
                                            <div class="side-title">{{ $t('tour.precheck.other') }}</div>
                                        </div>

                                        <div class="row-cnt-just">
                                            <input ref="student" class="side-item text-num"
                                                name="studentNo"
                                                v-model=studentNo
                                                inputmode="numeric"
                                                autocomplete="off"
                                                @focus="$refs.student.select()"
                                                :style="{ 'background-color' : errorTotalNo ? 'pink' : 'white' }"
                                                type="text">
                                            <input ref="teacher" class="side-item text-num"
                                                name="teacherNo"
                                                v-model=teacherNo
                                                inputmode="numeric"
                                                @focus="$refs.teacher.select()"
                                                autocomplete="off"
                                                :style="{ 'background-color' : errorTotalNo ? 'pink' : 'white' }"
                                                type="text">
                                            <input ref="nurse" class="side-item text-num"
                                                name="nurseNo"
                                                v-model=nurseNo
                                                inputmode="numeric"
                                                @focus="$refs.nurse.select()"
                                                autocomplete="off"
                                                :style="{ 'background-color' : errorTotalNo ? 'pink' : 'white' }"
                                                type="text">
                                            <input ref="camera" class="side-item text-num"
                                                name="cameraNo"
                                                v-model=cameraNo
                                                inputmode="numeric"
                                                @focus="$refs.camera.select()"
                                                autocomplete="off"
                                                :style="{ 'background-color' : errorTotalNo ? 'pink' : 'white' }"
                                                type="text">
                                            <input ref="other" class="side-item text-num"
                                                name="otherNo"
                                                v-model=otherNo
                                                inputmode="numeric"
                                                @focus="$refs.other.select()"
                                                autocomplete="off"
                                                :style="{ 'background-color' : errorTotalNo ? 'pink' : 'white' }"
                                                type="text">
                                        </div>

                                        <div class="row-cnt-right">
                                            <label class="cnt-item">{{ $t('tour.precheck.total') }}</label>
                                            <label class="cnt-item" v-if=showTotalNo>{{ totalNo }}</label>
                                        </div>
                                    </div>

                            </div>
                        </div>

                        <div class="row mt-4 no-gutters">
                            <div class="col-6 pr-2">
                                <button
                                    class="btn btn-pink-53 w-100 ex-orange-light"
                                    @click="nextOfficialRegistration"
                                >{{ $t('button.next') }}</button>
                            </div>

                            <div class="col-6 pl-2">
                                <button class="btn btn-gray-53 w-100" data-dismiss="modal">{{ $t('button.cancel') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ja';

import StorageService from "@/services/common/storage.service";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

export default {
    name: "PcEditTourInfoModal",
    props: {
    },
    components: {
        DatePicker
    },
    data () {
        let tourInfo = JSON.parse(StorageService.getTour());
        if (!Utils.isEmptyObj(tourInfo)) {
            tourInfo.departure_date = new Date(tourInfo.departure_date);
            tourInfo.return_date = new Date(tourInfo.return_date);
        }
        return {
            tourInfo: tourInfo,
            studentNo: "",
            teacherNo: "",
            nurseNo: "",
            cameraNo: "",
            otherNo: "",
            totalNo: "",
            showTotalNo: false,

            errorTourName: false,
            errorDepartureDate: false,
            errorReturnDate: false,
            errorPersonCount: false,
            errorConductorNumber: false,
            errorTotalNo: false,
            storageService: StorageService,
        };
    },
    methods: {
        init() {
            let tourInfo = JSON.parse(StorageService.getTour());
            if (!Utils.isEmptyObj(tourInfo)) {
                tourInfo.departure_date = new Date(tourInfo.departure_date);
                tourInfo.return_date = new Date(tourInfo.return_date);
            }

            this.tourInfo = tourInfo;
            this.studentNo = "";
            this.teacherNo = "";
            this.nurseNo = "";
            this.cameraNo = "";
            this.otherNo = "";
            this.totalNo = "";
            this.showTotalNo = false;

            this.errorTourName = false;
            this.errorDepartureDate = false;
            this.errorReturnDate = false;
            this.errorPersonCount = false;
            this.errorConductorNumber = false;
            this.errorTotalNo = false;
        },
        nextOfficialRegistration () {
            let validate = this.checkValidate();
            if (validate) {
                this.tourInfo.showTotal_number = this.showTotalNo;
                this.tourInfo.student_number = this.studentNo ? this.studentNo : "";
                this.tourInfo.teacher_number = this.teacherNo ? this.teacherNo : "";
                this.tourInfo.nurse_number = this.nurseNo ? this.nurseNo : "";
                this.tourInfo.camera_number = this.cameraNo ? this.cameraNo : "";
                this.tourInfo.other_number = this.otherNo ? this.otherNo : "";

                this.$emit('confirmRegister', this.tourInfo);
            } else {
                return;
            }
        },

        checkValidate () {
            let result = true;
            let tourInfo = this.tourInfo;
            let msg = "";

            this.errorTourName = false;
            this.errorDepartureDate = false;
            this.errorReturnDate = false;
            this.errorPersonCount = false;
            this.errorConductorNumber = false;
            this.errorTotalNo = false;

            if (Utils.isEmptyStr(tourInfo.name)) {
                result = false;
                this.errorTourName = true;
                msg = this.$root.$t("tour.tour_number") + this.$root.$t("voucher.validation.required");
            }

            if (result && Utils.isEmptyStr(DateUtils.formatDate(tourInfo.departure_date))) {
                result = false;
                this.errorDepartureDate = true;
                msg = this.$root.$t("tour.departure_date") + this.$root.$t("voucher.validation.required")
            }

            if (result && Utils.isEmptyStr(DateUtils.formatDate(tourInfo.return_date))) {
                result = false;
                this.errorReturnDate = true;
                msg = this.$root.$t("tour.return_date") + this.$root.$t("voucher.validation.required")
            }

            if (result && (tourInfo.departure_date > tourInfo.return_date && DateUtils.formatDate(tourInfo.departure_date) != DateUtils.formatDate(tourInfo.return_date))) {
                result = false;
                this.errorDepartureDate = true;
                this.errorReturnDate = true;
                msg = this.$root.$t("tour.precheck.message.msg_depAndReturnDate");
            }

             let exp = /^[0-9]\d*$/;
            if (result) {
                let personCount = String(tourInfo.person_count);
                if (personCount.length == 0) {
                    result = false;
                    this.errorPersonCount = true;
                    msg = this.$root.$t("tour.person_count") + this.$root.$t("voucher.validation.required")
                } else if (!exp.test(personCount)) {
                    result = false;
                    this.errorPersonCount = true;
                    msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.person_count')]);
                }
            }

            if (result) {
                let conductorNumber = String(tourInfo.conductor_number);
                if (conductorNumber.length == 0) {
                    result = false;
                    this.errorConductorNumber = true;
                    msg = this.$root.$t("tour.conductor_number") + this.$root.$t("voucher.validation.required")
                } else if (!exp.test(conductorNumber)) {
                    result = false;
                    this.errorConductorNumber = true;
                    msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.conductor_number')]);
                }
            }

            if (result && String(this.studentNo).length != 0 && !exp.test(this.studentNo)) {
                result = false;
                this.errorTotalNo = true;
                msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.precheck.student')]);
            }

            if (result && String(this.teacherNo).length != 0 && !exp.test(this.teacherNo)) {
                result = false;
                this.errorTotalNo = true;
                msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.precheck.teacher')]);
            }

            if (result && String(this.nurseNo).length != 0 && !exp.test(this.nurseNo)) {
                result = false;
                this.errorTotalNo = true;
                msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.precheck.nurse')]);
            }

            if (result && String(this.cameraNo).length != 0 && !exp.test(this.cameraNo)) {
                result = false;
                this.errorTotalNo = true;
                msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.precheck.cameraman')]);
            }

            if (result && String(this.otherNo).length != 0 && !exp.test(this.otherNo)) {
                result = false;
                this.errorTotalNo = true;
                msg = this.$root.$t("tour.precheck.message.msg_number", [this.$root.$t('tour.precheck.other')]);
            }

            if (result && this.totalNo && tourInfo.person_count != this.totalNo) {
                result = false;
                this.errorTotalNo = true;
                this.errorPersonCount = true;
                msg = this.$root.$t("tour.precheck.message.msg_totalNo");
            }


            if (!Utils.isEmptyStr(msg)) {
                this.$toasted.error(msg, {});
            }

            return result;
        },
    },
    watch: {
        'personCount': function() {
            this.personCount = Utils.toSingle(this.personCount);
        },
        'conductorNumber': function() {
            this.conductorNumber = Utils.toSingle(this.conductorNumber);
        },

        'studentNo': function() {
            this.studentNo = Utils.toSingle(this.studentNo);
            this.totalNo = Number(this.studentNo ? this.studentNo : 0) + Number(this.teacherNo ? this.teacherNo : 0) + Number(this.nurseNo ? this.nurseNo : 0) + Number(this.cameraNo ? this.cameraNo : 0) + Number(this.otherNo ? this.otherNo : 0);
            this.totalNo = !isNaN(this.totalNo) ? this.totalNo : 0;
            this.showTotalNo = this.totalNo != 0;
        },
        'teacherNo': function() {
            this.teacherNo = Utils.toSingle(this.teacherNo);
            this.totalNo = Number(this.studentNo ? this.studentNo : 0) + Number(this.teacherNo ? this.teacherNo : 0) + Number(this.nurseNo ? this.nurseNo : 0) + Number(this.cameraNo ? this.cameraNo : 0) + Number(this.otherNo ? this.otherNo : 0);
            this.totalNo = !isNaN(this.totalNo) ? this.totalNo : 0;
            this.showTotalNo = this.totalNo != 0;
        },
        'nurseNo': function() {
            this.nurseNo = Utils.toSingle(this.nurseNo);
            this.totalNo = Number(this.studentNo ? this.studentNo : 0) + Number(this.teacherNo ? this.teacherNo : 0) + Number(this.nurseNo ? this.nurseNo : 0) + Number(this.cameraNo ? this.cameraNo : 0) + Number(this.otherNo ? this.otherNo : 0);
            this.totalNo = !isNaN(this.totalNo) ? this.totalNo : 0;
            this.showTotalNo = this.totalNo != 0;
        },
        'cameraNo': function() {
            this.cameraNo = Utils.toSingle(this.cameraNo);
            this.totalNo = Number(this.studentNo ? this.studentNo : 0) + Number(this.teacherNo ? this.teacherNo : 0) + Number(this.nurseNo ? this.nurseNo : 0) + Number(this.cameraNo ? this.cameraNo : 0) + Number(this.otherNo ? this.otherNo : 0);
            this.totalNo = !isNaN(this.totalNo) ? this.totalNo : 0;
            this.showTotalNo = this.totalNo != 0;
        },
        'otherNo': function() {
            this.otherNo = Utils.toSingle(this.otherNo);
            this.totalNo = Number(this.studentNo ? this.studentNo : 0) + Number(this.teacherNo ? this.teacherNo : 0) + Number(this.nurseNo ? this.nurseNo : 0) + Number(this.cameraNo ? this.cameraNo : 0) + Number(this.otherNo ? this.otherNo : 0);
            this.totalNo = !isNaN(this.totalNo) ? this.totalNo : 0;
            this.showTotalNo = this.totalNo != 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/EditTourInfoModal.vue